import * as React from 'react';

export interface SurveyProgressProps {
  current: number;
  total: number;
}

/**
 * @name SurveyProgress
 * @description Right now this is just a persistent progress bar that
 * sits at the top of the survey and updates as you progress.
 */
export const SurveyProgress = (props: SurveyProgressProps) => {
  const { current, total } = props;

  // Setup
  const percentage = (current / total) * 100;
  const value = Math.floor(percentage);

  return (
    <div className="absolute top-0 left-0 right-0">
      <div className="relative h-2 w-full border-2 bg-forest">
        <div
          className="absolute left-0 h-full rounded-r-lg bg-pine transition-all duration-700 ease-in-out"
          style={{ right: `${100 - value}%` }}
        />
      </div>
    </div>
  );
};
